/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/common/app-config.service';
import { DataAccessService } from '@app/common/data-access.service';
import { Count } from '@core/lib/components/to-do-count/count';
import { CountUpdate } from '@app/data-model/count-update';
import { UserPrivilegesService } from '@app/common/user-privileges.service';

@Injectable({
  providedIn: 'root'
})
export class DatabaseListService {
  constructor(
    private dataAccess: DataAccessService,
    private userPrivilegesService: UserPrivilegesService,
    private appConfigService: AppConfigService
  ) {}

  populateNextPage(list: any, start = 1): Promise<any> {
    const groupByPatientContext = this.appConfigService.getGroupByPatientContext();
    const currentContextPtId = groupByPatientContext ? groupByPatientContext.groupByCurrentContextPatientId : null;
    const currentPatientGroupingIndex = groupByPatientContext
      ? groupByPatientContext.currentPatientGroupingIndex
      : null;
    const end = start + this.appConfigService.getWorklistPageSize() - 1;

    const params = { pageStart: start, pageEnd: end } as any;
    if (list.isFiltered) {
      params.filter = list.filterData;
    }
    if (list.isSorted) {
      params.sort = list.sortData;
    }

    const protocolWorklist = list.protocolWorklist;
    params.protocolWorklist = protocolWorklist;

    if (currentContextPtId !== null && currentPatientGroupingIndex !== null) {
      params.currentContextPatientId = currentContextPtId;
      params.currentPatientGroupingIndex = currentPatientGroupingIndex;
    }

    return new Promise((resolve, reject) => {
      const workItemPromise = this.dataAccess.getWorkItems('worklists', list.id, params);
      workItemPromise.then(
        (data: any) => {
          if (data.count && data.available) {
            const countUpdate: CountUpdate = new CountUpdate(
              data.count,
              this.userPrivilegesService.hasPrivilege('ViewConfidentialPatient'),
              Array.isArray(this.userPrivilegesService.institutes) ? this.userPrivilegesService.institutes : [],
              this.appConfigService.isInstituteSeparationEnabled()
            );
            list.count = new Count(
              countUpdate.total,
              countUpdate.stat,
              countUpdate.findings,
              countUpdate.isUnmonitored
            );
          }
          if (!data.items) {
            resolve(undefined);
            if (list.isFiltered) {
              list.count = new Count(0, 0, 0);
            }
            return;
          }
          resolve(data.items);
        },
        error => {
          //error handling exists elsewhere in the application, just reject the promise
          reject(error);
        }
      );
    });
  }
}
